import { render } from "./WarningMessage.vue?vue&type=template&id=74dc60ef&scoped=true"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"

import "./WarningMessage.vue?vue&type=style&index=0&id=74dc60ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dc60ef"]])

export default __exports__